import React from "react";
import Language from "../Language";


export default function Italian({children, invert}) {
    return (
        <Language code={"it"} invert={invert}>
            {children}
        </Language>
    )
}
